import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import { useTheme } from '../../../contexts/ThemeContext';
import logo from '../../../assets/images/logo 512.png';
import './DashboardHeader.css';

interface DashboardHeaderProps {
  areaLabel: string;
  notifPath?: string;
  unreadCount?: number;
}

const DashboardHeader: React.FC<DashboardHeaderProps> = ({
  areaLabel,
  notifPath,
  unreadCount = 0,
}) => {
  const { user, logout } = useAuth();
  const { isDarkMode, toggleTheme } = useTheme();

  const initials = user
    ? `${user.firstName[0]}${user.lastName[0]}`.toUpperCase()
    : '?';

  return (
    <header className="dl-header">
      <Link to="/" className="dl-header-logo" aria-label="Torna al sito">
        <img src={logo} alt="Benessere Posturale" height="36" />
        <span className="dl-header-brand">
          <span className="dl-header-brand-name">Benessere Posturale</span>
          <span className="dl-header-area-label">{areaLabel}</span>
        </span>
      </Link>

      <div className="dl-header-actions">
        <button
          className="dl-header-btn"
          onClick={toggleTheme}
          aria-label={`Passa a modalità ${isDarkMode ? 'chiara' : 'scura'}`}
        >
          <i className={`bi ${isDarkMode ? 'bi-sun' : 'bi-moon'}`} />
        </button>

        {notifPath && (
          <Link
            to={notifPath}
            className="dl-header-btn dl-header-notif"
            aria-label="Notifiche"
          >
            <i className="bi bi-bell" />
            {unreadCount > 0 && (
              <span className="dl-header-badge">
                {unreadCount > 9 ? '9+' : unreadCount}
              </span>
            )}
          </Link>
        )}

        <div className="dl-header-user">
          <div className="dl-header-avatar" aria-hidden="true">
            {user?.avatarUrl ? (
              <img src={user.avatarUrl} alt={user.firstName} />
            ) : (
              initials
            )}
          </div>
          <span className="dl-header-name">{user?.firstName}</span>
        </div>

        <button
          className="dl-header-btn dl-header-logout"
          onClick={logout}
          aria-label="Esci dall'account"
          title="Esci"
        >
          <i className="bi bi-box-arrow-right" />
        </button>
      </div>
    </header>
  );
};

export default DashboardHeader;
